import { PermissionType } from "../../../Core/Api/Types/permission-type";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import PermissionSummary from "../Shared/permission-summary";

interface ExternalAccessPermissionSummaryProps {
  permissions: PermissionType[];
  showTooltip?: boolean;
}

const ExternalAccessPermissionSummary = (props: ExternalAccessPermissionSummaryProps) => {
  const { permissions, showTooltip } = props;

  return (
    <PermissionSummary
      selectedPermissions={permissions}
      variant="info"
      allowedPermissions={GlobalConst.EXTERNAL_ACCESS_ALLOWED_PERMISSIONS}
      showTooltip={showTooltip}
    />
  );
};

export default ExternalAccessPermissionSummary;
